<template>
  <form-section :title="$t('ApplicationForm_Row_ApplicationSettingsTitle')">
    <el-form :model="model" :disabled="readonly">
      <el-row>
        <el-col :span="8">
          <form-item
            prop="ios_production_key_file"
            :label="$t('ApplicationForm_Field_ProductionCertificate')"
            :hint="productionExpiryDate"
          >
            <certificate-upload
              :value="model.ios_production_key"
              :file.sync="model.ios_production_key_file"
              :password.sync="model.ios_production_key_password"
            />
          </form-item>
        </el-col>
        <el-col :span="8">
          <form-item
            prop="ios_sandbox_key_file"
            :label="$t('ApplicationForm_Field_SandboxCertificate')"
            :hint="sandboxExpiryDate"
          >
            <certificate-upload
              :value="model.ios_sandbox_key"
              :file.sync="model.ios_sandbox_key_file"
              :password.sync="model.ios_sandbox_key_password"
            />
          </form-item>
        </el-col>
      </el-row>
    </el-form>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import FormItem from '@/common/components/form/FormItem'
import CertificateUpload from '@/common/components/form/CertificateUpload'
import moment from 'moment'
export default {
  name: 'PushSettingsIos',
  components: { CertificateUpload, FormItem, FormSection },
  data() {
    return {}
  },
  props: {
    model: {
      required: true,
      type: Object
    },
    readonly: {
      type: Boolean,
      default: false
    },
    dateFormat: {
      type: String,
      default: 'YYYY-MM-DD HH:mm'
    }
  },
  computed: {
    productionExpiryDate() {
      if (!this.model.iosProductionCertificateExpiryDate) {
        return
      }
      return this.$t('PushSettingsTab_ExpiryDate', {
        date: moment
          .unix(this.model.iosProductionCertificateExpiryDate)
          .format(this.dateFormat)
      })
    },
    sandboxExpiryDate() {
      if (!this.model.iosSandboxCertificateExpiryDate) {
        return
      }

      return this.$t('PushSettingsTab_ExpiryDate', {
        date: moment
          .unix(this.model.iosSandboxCertificateExpiryDate)
          .format(this.dateFormat)
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/modules/settings/components/PushSettingsIos.vue